export default "__VITE_ASSET__BK491l3x__"